import React from "react";
import "./style/image-grid.css"; // Importa il file CSS
import AnemoneImg from "../atoms/anemoneImg";
import VintageImg from "../atoms/vintageImg";
import CoralImg from "../atoms/coralImg";
import ButterflyImg from "../atoms/butterflyImg";

function ImageGrid() {
	// const [dimensions, setDimensions] = useState({
	// 	height: window.innerHeight,
	// 	width: window.innerWidth
	//   })
	// 	useEffect(() => {
	// 	const debouncedHandleResize = debounce(function handleResize() {
	// 	  setDimensions({
	// 		height: window.innerHeight,
	// 		width: window.innerWidth
	// 	  })
	// 	}, 1000)

	// 	window.addEventListener('resize', debouncedHandleResize)

	// 	return _ => {
	// 	  window.removeEventListener('resize', debouncedHandleResize)

	// }
	//   })
	return (
		<div className="image-grid">
			<div className="image-background">
				<div className="image-overlay-first-row"></div>
				<div className="image-overlay-second-row"> </div>
				<div className="image-overlay-third-row"> </div>
				<div className="image-overlay-fourth-row"> </div>
			</div>
			<div className="left-image-box">
				{/* <a href="linkcollection" target="_blank">
					Clicca qui
				</a> */}
				{/* <ImageWithTooltip/> */}
				<CoralImg />
				<div className="first-paragraph">
					<h2 className="image-title">Ocean Waves</h2>
					<p className="image-text">
						Breath-taking cuff bracelet and earrings <br />
						inspired by the harmonious <br />
						grace of ocean waves
					</p>
					<ul>
						<li style={{ textAlign: "center", marginTop: "7%" }}>
							<a
								href="https://www.1stdibs.com/it/gioielli/bracciali/bracciali-cuff/zaffiri-blu-diamanti-oro-bianco-18-carati-bracciale-waves-made-in-italy/id-j_445752/"
								target="_blank"
								rel="noreferrer"
								className="jewel-link"
							>
								Discover the jewels
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="right-image-box">
				<AnemoneImg />
				<div className="second-paragraph">
					<h2 className="image-title">Cocktail Rings</h2>
					<p className="image-text">
						Inspired by the shapes of the sea anemone, <br />
						the rings feature protruding pillars <br />
						with vibrant natural gemstones, <br />
						while at the center sits a sun-kissed special gem
					</p>
					<ul>
						<li style={{ textAlign: "center", marginTop: "7%" }}>
							<a
								href="https://www.1stdibs.com/it/gioielli/anelli/anelli-cocktail/anello-da-cocktail-in-oro-bianco-18-carati-con-berillo-giallo-e-tsavoriti-verdi-realizzato-artigianalmente/id-j_680752/"
								target="_blank"
								rel="noreferrer"
								className="jewel-link"
							>
								Discover the jewels
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="left-image-box">
				<ButterflyImg />
				<div className="third-paragraph">
					<h2 className="image-title">Vintage Brooches</h2>
					<p className="image-text">
						Wonderful vintage butterfly brooches <br />
						made in 18 karat gold <br />
						with refined enamel <br />
					</p>
					<ul>
						<li style={{ textAlign: "center", marginTop: "7%" }}>
							<a
								href="https://www.1stdibs.com/it/gioielli/spille/spille/spilla-farfalla-con-diamanti-e-smalto-in-oro-giallo/id-j_13384042/"
								target="_blank"
								rel="noreferrer"
								className="jewel-link"
							>
								Discover the jewels
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div className="right-image-box">
				<VintageImg />
				<div className="fourth-paragraph">
					<h2 className="image-title">Antique Jewels</h2>
					<p className="image-text">
						Elegant antique jewels <br />
						made in 18 karat gold <br />
						with precious gemstones <br />
					</p>
					<ul>
						<li style={{ textAlign: "center", marginTop: "7%" }}>
							<a
								href="https://www.1stdibs.com/it/gioielli/bracciali/bracciali-a-maglie/bracciale-con-pietre-naturali-in-oro-rosa-18k/id-j_17274372/"
								target="_blank"
								rel="noreferrer"
								className="jewel-link"
							>
								Discover the jewels
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default ImageGrid;
